import { Checkbox, FormControlLabel } from '@mui/material';
import { useEffect, useState } from 'react';
import dotenv from 'react-dotenv';
import { useDispatch, useSelector } from 'react-redux';
import { getIAAM } from '../../../reducer/iaamSlice';
import { getWeekOfYear } from '../../../reducer/weekOfYearSlice';

import { setNCOChecked, setNCOValue } from '../../../reducer/LarvaIndexSlice';
import { getDengueSetting, setDengueNco } from '../../../reducer/dengueSettingSlice';


function CISetting(props) {
    const dispatch = useDispatch();
    const { nco } = useSelector(getDengueSetting);
    const iaam = useSelector(getIAAM);
    const woy = useSelector(getWeekOfYear);
    const [checked, setChecked] = useState(false);
    

    useEffect(() => {
        const getAPI = async () => {
            let access_token = await iaam.getAccessToken();
            let options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json', 
                    'Authorization': `bearer ${access_token}`
                }
            }

            let res = await iaam.fetch(`${dotenv.SECURE_API_URL}/report/larval_survey_place_report?co=false&start_date=${woy.start.from}&end_date=${woy.end.to}`, options);
            const resData = await res.json();
            let tmpData = [];
            for (let index = 0; index < resData.length; index++) {
                const element = resData[index];

                let place_type = element.place_type_id;
                let imageName;
                if (place_type === 2) {
                    var place_subtype = element.place_subtype_id;
                    imageName = place_type + "_" + place_subtype;
                } else {
                    imageName = place_type;
                }
                var color = "#D92405";
                var zIndex = 199;
                let value = parseFloat(element.ci);
                if (value === 0) {
                    color = "#41A30D";
                    zIndex = 197;
                } else if (value <= 5) {
                    color = "#FFCE38";
                    zIndex = 198;
                }
                let data = {
                    ...element,
                    color: color,
                    zIndex: zIndex,
                    imageSrc: imageName + ".png"   
                }
                tmpData.push(data);
            }
            dispatch(setNCOValue(tmpData));

        }
        if (iaam) {
            if (checked) {
                // dispatch(setCluster({}));
                dispatch(setNCOValue([]));
                dispatch(setNCOChecked(true));
                getAPI();   
            } else {
                dispatch(setNCOValue([]));
                dispatch(setNCOChecked(false));
                // dispatch(setCluster({}));
            }
        }
    }, [checked, iaam, woy, dispatch])

    useEffect(() => {
        setChecked(nco);
    }, [nco])

    return (
        <>
            <FormControlLabel control={<Checkbox checked={checked} onChange={(event) => {
                dispatch(setDengueNco(event.target.checked))
                // setChecked(event.target.checked);
            }}/>} label="ดัชนีทางกีฏวิทยาในสถานที่อื่นๆ" />
        </>
    )
}

export default CISetting;